import { Utils } from "@app-services/utils.service";
import { ClientType } from "@enums/client-type.enum";
import { IStorageService } from "@interfaces/storage-service.interface";
import { RoamingStorageService } from "@storage-services/roaming-storage.service";
import { LocalStorageService } from "@storage-services/local-storage.service";

export function getStorageService(): IStorageService {
    const clientType = Utils.getClientType();

    switch (clientType) {

        case ClientType.Windows:
            return new RoamingStorageService();

        case ClientType.Mac:
        case ClientType.Web:
            return new LocalStorageService();

        default:
            throw Error("Client type not supported");
    }
}